import { useEffect, useState } from "react";
import { API } from "../core/api";
import { useSelector } from "react-redux";
import { Note } from "../components/Note";
import { useHistory, useLocation } from "react-router-dom";
import { onChangeProvince, toEnglishNumber } from "../core/utils";
import { parse, stringify } from "query-string";
import FileSaver from "file-saver";

const useCars = ({
  setIsModalOpen,
  onFilterDrivers,
  isInCarsPage,
  isCarDedicationModalOpen,
}) => {
  const history = useHistory();
  const location = useLocation();
  const params = parse(location.search);
  const [loading, setLoading] = useState(false);
  const [cars, setCars] = useState(null);
  const [companyEmployeeCars, setCompanyEmployeeCars] = useState(null);
  const [cities, setCities] = useState([]);
  const [brands, setBrands] = useState([]);
  const [models, setModels] = useState([]);
  const [selectedCar, setSelectedCar] = useState(null);
  const provinces = useSelector((state) => state.Store.provinces);

  const [addCarStates, setAddCarStates] = useState({
    car_id: null,
    number_plate_part_1: "",
    number_plate_part_2: "",
    number_plate_alphabet: "",
    number_plate_city_code: "",
    car_type: null,
    brand: null,
    year: null,
    province_id: null,
    city_id: null,
    capacity: null,
    capacity_unit: null,
    usage: null,
    vin: null,
  });

  const handleAddCarState = (data) => {
    setAddCarStates({
      ...addCarStates,
      ...data,
    });
  };

  const [filters, setFilters] = useState({
    car_id: params.car_id || null,
    year: params.year || null,
    capacity: params.capacity || null,
    usage: params.usage || null,
    province_id: params.province_id || null,
    city_id: params.city_id || null,
    car_type: params.car_type || null,
    brand: params.brand || null,
    search: params.search || null,
  });
  const [editState, setEditState] = useState({
    type: null,
    car_id: null,
    year: null,
    province_id: null,
    city_id: null,
    capacity: null,
    capacity_unit: null,
    usage: null,
    vin: null,
  });

  const onChangeFilters = (data) => {
    setFilters({ ...filters, ...data });
  };

  const getCars = (page, disableFilters = false) => {
    // setLoading(true);
    const newFilters = {
      ...filters,
      search:
        filters.search && !isNaN(toEnglishNumber(filters.search))
          ? toEnglishNumber(filters.search)
          : filters.search,
    };
    if (isInCarsPage && !disableFilters)
      history.push({ pathname: "/cars/", search: stringify(newFilters) });

    // API.get
    //     .cars(
    //         disableFilters
    //             ? {}
    //             : {
    //                 ...newFilters,
    //                 ...((page || cars?.pagination) && {
    //                     page: page || cars?.pagination?.page,
    //                 }),
    //             }
    //     )
    //     .then((response) => {
    //         setLoading(false);
    //         if (response.success) {
    //             setCars(response);
    //         } else {
    //             Note.error(response.message);
    //         }
    //     });
  };

  const getCarsReport = () => {
    const newFilters = {
      ...filters,
      search:
        filters.search && !isNaN(toEnglishNumber(filters.search))
          ? toEnglishNumber(filters.search)
          : filters.search,
      get_report: true,
    };
    // API.get.cars_report(newFilters).then((response) => {
    //     if (response.status === 200) {
    //         return response.blob();
    //     } else {
    //         Note.error(response.message);
    //     }
    // }).then((blob) => {
    //     FileSaver.saveAs(blob, `cars-report.xlsx`);
    // })
  };

  const getEmplooyeCars = () => {
    // API.get.company_employee_cars(filters).then((response) => {
    //   if (response.success) {
    //     setCompanyEmployeeCars(response);
    //   } else {
    //     Note.error(response.message);
    //   }
    // });
  };

  const getCarsBrands = (type) => {
    // API.get.cars_brands(type).then((response) => {
    //   if (response.success) {
    //     setBrands(response.data);
    //   } else {
    //     Note.error(response.message);
    //   }
    // });
  };

  const getCarsModels = (brand_id) => {
    // API.get.cars_models(brand_id).then((response) => {
    //   if (response.success) {
    //     setModels(response.data);
    //   } else {
    //     Note.error(response.message);
    //   }
    // });
  };

  const onSetCompanyEmployeeCar = (id) => {
    if (!selectedCar) {
      return Note.error("لطفا خودرو موردنظر را انتخاب کنید.");
    }
    // API.post.set_company_employee_car(id, selectedCar?.id).then((response) => {
    //   if (response.success) {
    //     setIsModalOpen(false);
    //     setSelectedCar(null);
    //     getCars();
    //     onFilterDrivers();
    //     Note.success(response.message);
    //   } else {
    //     Note.error(response.message);
    //   }
    // });
  };

  const onAddCar = (data) => {
    // API.post.add_car(data).then((response) => {
    //   if (response.success) {
    //     setIsModalOpen(false);
    //     Note.success(response.message);
    //     getCars();
    //     setAddCarStates({
    //       car_id: null,
    //       number_plate_part_1: "",
    //       number_plate_part_2: "",
    //       number_plate_alphabet: "",
    //       number_plate_city_code: "",
    //       car_type: null,
    //       brand: null,
    //       year: null,
    //       province_id: null,
    //       city_id: null,
    //       capacity: null,
    //       capacity_unit: null,
    //       usage: null,
    //       vin: null,
    //     });
    //   } else {
    //     Note.error(response.message);
    //   }
    // });
  };

  const onEditCar = (id, onSuccess) => {
    const { city_id, year, car_id, vin, capacity, capacity_unit, usage } =
      editState;

    if (!city_id) {
      return Note.error("لطفا شهر را وارد کنید");
    }

    if (!car_id) {
      return Note.error("لطفا مدل خودرو را انتخاب کنید");
    }

    if (!year) {
      return Note.error("لطفا سال خودرو را وارد کنید");
    }

    //     API.put
    //       .edit_car({
    //         specified_car_id: id,
    //         city_id,
    //         year,
    //         car_id,
    //         vin,
    //         capacity,
    //         capacity_unit,
    //         usage,
    //       })
    //       .then((response) => {
    //         if (response.success) {
    //           if (onSuccess) onSuccess();
    //           Note.success(response.message);
    //           getCars();
    //         } else {
    //           Note.error(response.message);
    //         }
    //       });
  };

  const changePage = (page) => {
    setCars({
      ...cars,
      pagination: {
        ...cars.pagination,
        page,
      },
    });
    getCars(page);
  };

  const error = {
    car_type: "نوع خودرو را وارد کنید",
    car_brand: "برند خودرو را وارد کنید",
    car_id: "مدل خودرو را وارد کنید",
    year: "سال خودرو را وارد کنید",
    province_id: "استان را وارد کنید",
    city_id: "شهر را وارد کنید",
    plate_number: "پلاک را وارد کنید",
    usage: "کاربری خودرو را وارد کنید",
    capacity: "ظرفیت خودرو را وارد کنید",
    capacity_unit: "واحد ظرفیت خودرو را وارد کنید",
    vin: "vin را وارد کنید",
  };

  const onAddCarValues = () => {
    switch (true) {
      case !addCarStates.car_type:
        return Note.error(error.car_type);
      case !addCarStates.brand:
        return Note.error(error.car_brand);
      case !addCarStates.car_id:
        return Note.error(error.car_id);
      case !addCarStates.year:
        return Note.error(error.year);
      case !addCarStates.province_id:
        return Note.error(error.province_id);
      case !addCarStates.city_id:
        return Note.error(error.city_id);
      case !addCarStates.number_plate_part_1 ||
        !addCarStates.number_plate_part_2 ||
        !addCarStates.number_plate_alphabet ||
        !addCarStates.number_plate_city_code:
        return Note.error(error.plate_number);
      case !addCarStates.usage:
        return Note.error(error.usage);
      case !addCarStates.capacity:
        return Note.error(error.capacity);
      case !addCarStates.capacity_unit:
        return Note.error(error.capacity_unit);
      case !addCarStates.vin:
        return Note.error(error.vin);
      default:
        break;
    }
    onAddCar(addCarStates);
  };

  useEffect(() => {
    getCars();
    getEmplooyeCars();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    if (isCarDedicationModalOpen >= 0 && isCarDedicationModalOpen !== false) {
      getEmplooyeCars();
    }
    // eslint-disable-next-line
  }, [isCarDedicationModalOpen]);

  useEffect(() => {
    if (params.province_id && !cities.length) {
      onChangeProvince(params.province_id, null, setCities);
    }
    // eslint-disable-next-line
  }, [history]);
  return {
    loading,
    cars,
    companyEmployeeCars,
    setCompanyEmployeeCars,
    selectedCar,
    setSelectedCar,
    provinces,
    cities,
    setCities,
    filters,
    setFilters,
    brands,
    setBrands,
    models,
    setModels,
    editState,
    setEditState,
    onChangeFilters,
    getCars,
    getEmplooyeCars,
    getCarsBrands,
    getCarsModels,
    onSetCompanyEmployeeCar,
    onAddCar,
    onAddCarValues,
    onEditCar,
    changePage,
    getCarsReport,
    handleAddCarState,
    addCarStates,
  };
};

export default useCars;
